import { Navigate } from "react-router-dom";
import { consumePostLoginRedirect, isAuthenticated, startSignIn } from "../lib/auth";
import { useDocumentTitle } from "../hooks/use-document-title";

export function LoginPage() {
  useDocumentTitle("Sign in");
  if (isAuthenticated()) {
    const target = consumePostLoginRedirect() ?? "/conversations";
    return <Navigate to={target} replace />;
  }
  return (
    <div className="login-page">
      <img src="/assets/logo.png" alt="Otto" className="login-logo" />
      <h1>Otto</h1>
      <p>Dealer assistant dashboard</p>
      <button className="btn btn-primary" type="button" onClick={() => void startSignIn()}>
        Continue with SSO
      </button>
    </div>
  );
}
